module.exports = __webpack_public_path__ + "officialStatic/img/index_x1.9451db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index_x1.png
// module id = CKeq
// module chunks = 0